<template>
  <div class="z-card__body">
    <recipient-input v-model="value" :need_show_range="false" @input="recive_numbers" />

    <div class="row mt-4">
      <div :class="`${is_hint ? 'col text-right tutorial-button' : 'col text-right'}`">
        <i-button type="default" size="large" @click="add_recipients">
          {{ $t('shared.component.recipient_form.button.add_recipients') }}
        </i-button>
      </div>
    </div>
  </div>
</template>

<script>
  import RecipientInput from '@shared/components/input/recipients/input-recipients';
  import cloneDeep from 'lodash-es/cloneDeep';
  import { RecipientModalService } from '@mailer/modals/RecipientModalService';

  export default {
    components: { RecipientInput },
    props: {
      value: {
        type: Object,
        default: function () {
          return {
            recipients: [],
            include: [],
            exclude: []
          };
        }
      },
      is_hint: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      recive_numbers: function (numbers) {
        this.$emit('input', numbers);
      },

      add_recipients: function () {
        RecipientModalService.select({
          value: cloneDeep(this.value)
        }).on('success', (res) => {
          this.$emit('input', res);
        });
      }
    }
  };
</script>
